import { defineMessages } from '@/lib/i18n';

const m = defineMessages({
  fullDigitizationLabel: '15章までのデータ化希望（改訂日から5年経過したSDS）',
  fullDigitizationCommentPlaceholder: '対象のSDSについて補足を記入してください',
  correctionLabel: 'データ化ミスの修正希望',
  correctionCommentPlaceholder: '誤っている項目と正しい内容を記入してください',
});

// 再データ化依頼フォームの「依頼内容」プルダウンの選択肢。
// value は backend の ReanalysisRequestType(enum.py) と一致させる。
export class ReanalysisRequestType {
  private static readonly _values: ReanalysisRequestType[] = [];

  static readonly FULL_DIGITIZATION = new ReanalysisRequestType(
    'FULL_DIGITIZATION',
    m.fullDigitizationLabel,
    m.fullDigitizationCommentPlaceholder
  );
  static readonly CORRECTION = new ReanalysisRequestType(
    'CORRECTION',
    m.correctionLabel,
    m.correctionCommentPlaceholder
  );

  private constructor(
    readonly value: string,
    readonly messageId: string,
    readonly commentPlaceholderMessageId: string
  ) {
    ReanalysisRequestType._values.push(this);
  }

  static values(): ReanalysisRequestType[] {
    return ReanalysisRequestType._values;
  }
}
